import { NOT_APPLICABLE_LABEL } from '@/constants';
import * as styles from './styles';

export type CustomBlockHighlightMarkerDataItem = {
  label: string;
  value: string | number | undefined;
};

export type CustomBlockHighlightMarkerProps = {
  title?: string;
  data: CustomBlockHighlightMarkerDataItem[];
};

export const CustomBlockHighlightMarker = ({
  title,
  data,
}: CustomBlockHighlightMarkerProps) => {
  return (
    <div style={styles.containerStyle}>
      <div style={styles.panelStyle}>
        {title && (
          <div style={styles.blockTitleStyle}>{title || NOT_APPLICABLE_LABEL}</div>
        )}

        {data.map(({ label, value }, index) => {
          const isLast = index === data.length - 1;
          return (
            <div key={label} style={isLast ? styles.lastRowStyle : styles.infoRowStyle}>
              <span style={styles.infoLabelStyle}>{label}</span>
              <span style={styles.infoValueStyle}>
                {value ?? NOT_APPLICABLE_LABEL}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
